module.exports = __webpack_public_path__ + "static/img/research.19646ecd.png";